module.exports = __webpack_public_path__ + "static/media/Portrait-10212.7ca8516b.jpg";